























































import { Event } from 'inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import { Form } from '../models/form';
import DynamicInfoList from './DynamicInfoList.vue';
import ModalConfirmation from './Modal.vue';

@Component({
  components: {
    DynamicInfoList,
    ModalConfirmation,
  },
})
export default class DynamicConfirmationComponent extends Vue {
  @Prop({ required: true })
  eventUi: EventUI;

  accept: boolean = null;

  private confirmation_modal!: ModalConfirmation;

  get form_values() {
    return Form.buildFormData(this.eventUi.event as unknown as Event, {
      withMeta: true,
      onlyGroup: 'personal-info',
      mode: 'iterable',
    });
  }

  get event() {
    return this.eventUi.event as Event;
  }

  mounted() {
    this.confirmation_modal = this.$refs.confirmation_modal as ModalConfirmation;
  }

  openTerm() {
    this.confirmation_modal.open();
  }

  close() {
    this.confirmation_modal.close();
  }
}
